import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux'; // to connect to redux store from containers redux.js or any other redux store
import cn from 'classnames'; // to use global class name eg.
import PropTypes from 'prop-types'; // to validate and set default props  coming to this component
import { is, Map } from 'immutable'; // use of immutablejs for various js operations to simplify our work
import renderIf from 'render-if';// to use conditional rendering based on values that is provided to component
import FullScreenLoader from 'components/FullScreenLoader';
// import UpgradeTiles from 'components/UpgradeTiles';
import Default from './Default/Default';
import DashboardNav from './dashboardnav';
import Requests from './requests/requests';
import Wishlist from './wishlist/wishlist';
import Tutorials from './Tutorial';
import CounterScreen from './Tutorial/Counter';
import styles from './DashboardView.scss';// to import local scss fle
import { selector } from './redux';
import { getSchools, getPostings, updateFilter, addToList, addToRequest, getRequests,
  removeFromList, initProfile, getTotalCounts, addStudentCurrentDivision, getRequestsViewedCount } from './actions';


class DashboardView extends Component {
  static propTypes = {
    getSchools: PropTypes.func.isRequired,
    getPostings: PropTypes.func.isRequired,
    getRequests: PropTypes.func.isRequired,
    initProfile: PropTypes.func.isRequired,
    profile: PropTypes.shape(),
    filter: PropTypes.shape.isRequired,
    profileId: PropTypes.string.isRequired,
    tab: PropTypes.number,
    contactedCount: PropTypes.number,
    recommendedDivision: PropTypes.string.isRequired, // eslint-disable-line
    addStudentCurrentDivision: PropTypes.string.isRequired,
    divisionAddRequested: PropTypes.bool.isRequired, // eslint-disable-line
    schools: PropTypes.shape(),
    postings: PropTypes.shape(),
    getRequestsViewedCount: PropTypes.func.isRequired,
    contacted: PropTypes.shape(),
    requestCount: PropTypes.number,
    requestViewedCount: PropTypes.number.isRequired,
    // syncFailed: PropTypes.bool.isRequired,
    subscribed: PropTypes.bool.isRequired,
    payload: PropTypes.bool.isRequired,
  };
  static defaultProps = {
    profile: Map(),
    schools: [],
    postings: [],
    wishList: [],
    contactedList: [],
    fillQList: [],
    inviteToCampList: [],
    ignoreList: [],
    tab: 0,
    requests: [],
    contacted: [],
    isLoading: false,
    contactedCount: 0,
    requestCount: 0,
  };


  constructor(props) {
    super(props);
    this.state = {
      value: '',
      gridView: true,
      showSchools: true,
      profileId: '',
      showFilter: true,
      showUpgrade: false,
      showSnackBar: false,
      snackBarLable: '',
      payload: {},
      showNotification: false,
      message: '',
      displayTutorial: true,
      showCounterScreen: false,
      onTrial: false,
    };
  }

  componentWillMount() {
    const localCount = window.localStorage.getItem('count');
    if (localCount === '111') {
      this.setState({ displayTutorial: false });
    }
  }

  componentDidMount() {
    // eslint-disable-next-line no-unused-vars
    const { subscribed, payload, profile } = this.props;
    if (profile.size > 0) {
      const PAYLOAD = payload.toJS();
      // if (profile.get('override_division') !== undefined) {
      //   const filterByDivision = [];
      //   filterByDivision.push(this.props.profile.get('override_division'));
      //   PAYLOAD['filter_divisions'] = filterByDivision; // eslint-disable-line
      // }
      if (profile.get('override_division') !== undefined || profile.get('current_division') !== undefined) {
        let filterByDivision = [];
        let currentDivision = [];
        const D1 = ['D1', 'D2', 'D3', 'NAIA', 'JUCO'];
        const D2 = ['D2', 'D3', 'NAIA', 'JUCO'];
        const D3 = ['D3', 'NAIA', 'JUCO'];
        const NAIA = ['NAIA', 'JUCO'];
        const JUCO = ['JUCO'];
        if (profile.get('current_division') !== undefined && profile.get('current_division') !== 'NA') {
          if (profile.get('current_division') === 'D1') currentDivision = D1;
          if (profile.get('current_division') === 'D2') currentDivision = D2;
          if (profile.get('current_division') === 'D3') currentDivision = D3;
          if (profile.get('current_division') === 'NAIA') currentDivision = NAIA;
          if (profile.get('current_division') === 'JUCO') currentDivision = JUCO;
          PAYLOAD['filter_divisions'] = currentDivision; // eslint-disable-line
        }
        if (profile.get('override_division') !== undefined) {
          if (profile.get('override_division') === 'D1') filterByDivision = D1;
          if (profile.get('override_division') === 'D2') filterByDivision = D2;
          if (profile.get('override_division') === 'D3') filterByDivision = D3;
          if (profile.get('override_division') === 'NAIA') filterByDivision = NAIA;
          if (profile.get('override_division') === 'JUCO') filterByDivision = JUCO;
          PAYLOAD['filter_divisions'] = filterByDivision; // eslint-disable-line
        }
      }
      this.props.initProfile(profile);
      // if (subscribed) {
      this.props.getSchools(PAYLOAD);
      this.props.getPostings(PAYLOAD);
      this.props.getRequestsViewedCount(profile.get('id'));
      this.props.getRequests(profile.get('id'));
      // }
    }
  }

  componentWillReceiveProps(nextProps) {
    const localCount = window.localStorage.getItem('count');
    if (localCount === '111') {
      this.setState({ displayTutorial: false });
    }
    const { profile, profileId, filter } = this.props;
    // eslint-disable-next-line no-unused-vars
    const { subscribed, payload } = nextProps;

    if (this.props.profile !== undefined) {
      if (this.props.profile.get('trialEndDate')) {
        this.setState({
          onTrial: moment().isBefore(this.props.profile.get('trialEndDate')),
        });
      }
    }

    const PAYLOAD = payload.toJS();
    // to fetch postings and colleges
    if (nextProps.profile.size > 0 && !is(profile, nextProps.profile)) {
      this.props.initProfile(nextProps.profile);
      // if (subscribed) {
      if (nextProps.profile.get('override_division') !== undefined || nextProps.profile.get('current_division') !== undefined) {
        let filterByDivision = [];
        let currentDivision = [];
        const D1 = ['D1', 'D2', 'D3', 'NAIA', 'JUCO'];
        const D2 = ['D2', 'D3', 'NAIA', 'JUCO'];
        const D3 = ['D3', 'NAIA', 'JUCO'];
        const NAIA = ['NAIA', 'JUCO'];
        const JUCO = ['JUCO'];
        if (nextProps.profile.get('current_division') !== undefined && nextProps.profile.get('current_division') !== 'NA') {
          if (nextProps.profile.get('current_division') === 'D1') currentDivision = D1;
          if (nextProps.profile.get('current_division') === 'D2') currentDivision = D2;
          if (nextProps.profile.get('current_division') === 'D3') currentDivision = D3;
          if (nextProps.profile.get('current_division') === 'NAIA') currentDivision = NAIA;
          if (nextProps.profile.get('current_division') === 'JUCO') currentDivision = JUCO;
            PAYLOAD['filter_divisions'] = currentDivision; // eslint-disable-line
        }
        if (nextProps.profile.get('override_division') !== undefined) {
          if (nextProps.profile.get('override_division') === 'D1') filterByDivision = D1;
          if (nextProps.profile.get('override_division') === 'D2') filterByDivision = D2;
          if (nextProps.profile.get('override_division') === 'D3') filterByDivision = D3;
            PAYLOAD['filter_divisions'] = filterByDivision; // eslint-disable-line
        }
      }

      this.props.getSchools(PAYLOAD);
      this.props.getPostings(PAYLOAD);
      this.props.getRequestsViewedCount(nextProps.profile.get('id'));
      // }

      // to fetch postings
      if (nextProps.profileId && nextProps.profileId !== profileId) {
        this.props.getRequests(nextProps.profileId);
      }

      // if sync fails by any chances or conditions fails in sync-handler.js
      // if (nextProps.syncFailed) {
      //   this.setState({ showCounterScreen: true });
      // }
    }

    // to handle filer changes
    if (!is(filter, nextProps.filter)) {
      if (nextProps.filter.get('apply')) {
        const requestBody = Object.assign({}, payload.toJS(), nextProps.filter.get('data')
          .toJS());
        this.props.getSchools(requestBody);
        this.props.getPostings(requestBody);
      }
    }

    if (nextProps.recommendedDivision !== '' && !nextProps.divisionAddRequested) {
      const payloadToaddCurrentDivision = {
        id: nextProps.profile.get('id'),
        current_division: nextProps.recommendedDivision,
      };
      this.props.addStudentCurrentDivision(payloadToaddCurrentDivision);
    }
  }
  toggleView = () => {
    this.setState({ gridView: !this.state.gridView });
  };

  toggleSchools = (show) => {
    if (show === 'school') {
      this.setState({ showSchools: true });
    } else {
      this.setState({ showSchools: false });
    }
  };

  toggleFilter = () => {
    this.setState({ showFilter: !this.state.showFilter });
  };

  showSnackBar = (label) => {
    this.setState({ showSnackBar: true, snackBarLable: label });
  };

  handleSnackbarTimeout = () => {
    this.setState({ showSnackBar: false });
  };

  addNotification = (msg) => {
    this.setState({ showNotification: true, message: msg });
    setTimeout(() => { this.setState({ showNotification: false }); }, 3000);
  };

  loadMoreColleges = () => {
    const payloadFilter = this.props.payload.toJS();
    payloadFilter['size'] = payloadFilter.size + this.props.contactedCount; // eslint-disable-line
    this.props.getSchools(payloadFilter);
  };

  showCounterpopUp = () => {
    this.setState({ showCounterScreen: !this.state.showCounterScreen });
  };

  render() {
    // console.log('state: ', this.state);
    // eslint-disable-next-line no-unused-vars
    const { tab, filter, subscribed, schools, postings, contacted,
            requestViewedCount, profile } = this.props;
    const { showFilter, showSchools, gridView, onTrial } = this.state;
    const renderIfWishList = renderIf(tab === 2);
    const renderIfContacted = renderIf(tab === 1);
    const renderIfDefault = renderIf(tab === 0);
    // const renderFilterSchools = tab === 0 && subscribed && showFilter;
    const renderFilterSchools = tab === 0 && showFilter;
//
    // const renderIfUpgrade = renderIf(!subscribed);
//     const renderIfNotUpgrade = renderIf(!this.state.showUpgrade);
    let loaderDecider = false;
    if (this.props.requestCount > 0) {
      loaderDecider = true;
    }
    let showCountOne = false;
    if (!subscribed) {
      if (this.props.profile.get('trialEndDate') !== undefined) {
        showCountOne = !moment().isBefore(this.props.profile.get('trialEndDate'));
      } else {
        showCountOne = true;
      }
    }
    const renderLoading = renderIf(loaderDecider);
//     const renderDashboardLoader = renderIf(false);
//
//     const renderFilterIcon = renderIf(this.props.tab === 0);
//     const renderNotification = renderIf(this.state.showNotification);
    // const renderTutorial = renderIf(this.state.displayTutorial && subscribed);
    const renderTutorial = renderIf(this.state.displayTutorial);
    let showTrialButton = false;
    if (this.props.profile.get('trialEndDate') === undefined && this.props.profile.get('payment_info') === undefined) {
      showTrialButton = true;
    }

//     const { showSchools } = this.state;
//     const renderRedText =
//     renderIf(this.props.syncData.get('count') === 2); // change it to perfect counter
    const renderCounterPopUp = renderIf(this.state.showCounterScreen);
    return (
      <div className={cn('row', styles.container)}>
        <DashboardNav
          tab={tab}
          toggleSchools={this.toggleSchools}
          toggleView={this.toggleView}
          toggleFilter={this.toggleFilter}
          filter={filter}
          renderFilterSchools={renderFilterSchools}
          showSchools={showSchools}
          showSnackBar={this.showSnackBar}
          {...this.props}
          onTrial={onTrial}
        />
        {renderIfDefault(
          <Default
            gridView={gridView}
            showSchools={showSchools}
            schools={schools}
            postings={postings}
            addNotification={this.addNotification}
            showCounterpopUp={this.showCounterpopUp}
            showSnackBar={this.showSnackBar}
            loadmoreColleges={this.loadMoreColleges}
            {...this.props}
            onTrial={onTrial}
          />,
        )}
        {renderIfWishList(
          <Wishlist
            gridView={gridView}
            showSchools={showSchools}
            schools={schools}
            postings={postings}
            addNotification={this.addNotification}
            showCounterpopUp={this.showCounterpopUp}
            showSnackBar={this.showSnackBar}
            {...this.props}
            onTrial={onTrial}
          />,
        )}

        {renderIfContacted(
          <Requests
            requests={contacted}
            gridView={gridView}
            subscribed
            requestViewedCount={requestViewedCount}
            onTrial={onTrial}
          />)}
        {renderLoading(<FullScreenLoader />)}
        {/* {renderIfUpgrade(<UpgradeTiles {...this.props} {...this.state} />)} */}
        {renderTutorial(<Tutorials />)}
        {renderCounterPopUp(
          <CounterScreen
            show={this.state.showCounterScreen}
            showCounterScreen={this.showCounterpopUp}
            showCountOne={showCountOne}
            onTrial={onTrial}
            subscribed={subscribed}
            showTrialButton={showTrialButton}
            saProfileID={profile.get('id')}
          />,
          )}
      </div>
    );
  }
}

export default connect(selector,
  { getSchools,
    getPostings,
    updateFilter,
    addToList,
    addToRequest,
    getRequests,
    removeFromList,
    initProfile,
    addStudentCurrentDivision,
    getTotalCounts,
    getRequestsViewedCount,
  })(DashboardView);



// WEBPACK FOOTER //
// ./src/components/DashboardView/DashboardView.js